module.exports = __webpack_public_path__ + "img/eclipse-top-angle.88697d84.png";